module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-50.b99b910b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-50.png
// module id = 3289
// module chunks = 11